import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IMG_PATH, BannerData, IPopupModelV2, ModalChild } from '@mwe/models';
import { EnvironmentService } from '@mwe/services';
import { ButtonComponent } from '../buttons/button/button.component';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'mwe-banner-popup',
  templateUrl: './banner-popup.component.html',
  imports: [ButtonComponent, ModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerPopupComponent implements ModalChild {
  // is set by popup service
  loadedData: BannerData;

  popupData = computed(() => this.loadedData?.popup);
  imageUrl = computed(() => {
    const popup = this.popupData();
    return popup?.image ? this.environmentService.staticContent() + IMG_PATH + popup.image : undefined;
  });

  popupModel = signal<IPopupModelV2>(null);

  private activeModal = inject(NgbActiveModal);
  private environmentService = inject(EnvironmentService);

  submit(): void {
    this.activeModal.close('OK');
  }

  cancel(): void {
    this.activeModal.dismiss('CANCEL');
  }
}
